import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify'; // Import toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'; //
const apiBase = process.env.REACT_APP_API;

const DaysLeft = ({ course_id, quota_id, isExpired, setIsExpired }) => {
  const [daysLeft, setDaysLeft] = useState(null);
  const [expiryStatus, setExpiryStatus] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDaysLeft = async () => {
      try {
        const token = localStorage.getItem("token"); // Assuming the token is stored in localStorage
        const response = await fetch(`${apiBase}/courses/checkifuserhaspaidformonth`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            course_id,
            quota_id,
          }),
        });

        const data = await response.json();

        console.log(data);

        if (response.ok) {
          setDaysLeft(data.daysLeft);

          // Explicitly check for expiry status
          if (data.daysLeft <= 0) {
            setExpiryStatus("expired");
            setIsExpired(true);
            toast.error("course has expired");
          } else {
            setExpiryStatus("active");
            setIsExpired(false);
          }
        } else {
          setError(data.message); // Display any error messages from the API
        }
      } catch (error) {
        setError("An error occurred while fetching the data.");
      }
    };

    fetchDaysLeft();
  }, [course_id, quota_id]);

  if (error) {
    return (
      <div className="right-5 bg-orange-500 text-white px-4 py-2 rounded-md shadow-md">
        <span>{error}</span>
      </div>
    );
  }

  if (daysLeft === null) return null; // Don't render until we have the data
  if(isExpired) return null;

  return (
    <div
      className = 
      {`right-5 px-4 py-2 rounded-md shadow-md text-white font-bold text-lg ${
        expiryStatus === "active" ? "bg-stone-500" : "bg-red-500"
      }`
      }
    >
      {expiryStatus === "expired" ? 
      (
        <span>Course Expired</span>
      ) : 
      (
        <span>{daysLeft} days left</span>
      )
      }
    </div>
  );
};

export default DaysLeft;
